import React from 'react';

import { ComingSoonChip } from 'src/components/chips';
import { useCardContext } from './card-context';

/** "Coming Soon" chip tag. Renders nothing when the product is not coming soon. */
export function CardComingSoonTag(): JSX.Element | null {
  const { isComingSoon } = useCardContext();

  if (!isComingSoon) {
    return null;
  }

  return <ComingSoonChip />;
}
